// extracted by mini-css-extract-plugin
export default {"contentBlock":"ContentBlock_contentBlock__TD6NW","hidden":"ContentBlock_hidden__BX1SC","shown":"ContentBlock_shown__P2omQ"};